<template>
  <div>
    <div v-if="isOpen" class="modal d-block" role="dialog">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Mail overzicht</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <iframe
              v-if="modelValue"
              :src="mailUrl"
              class="w-100"
              style="height: 600px"
            />

            <NoteForm v-model="note" />

            <hr />

            <p>Deze mail wordt verzonden naar: {{ mails }}</p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click="send"
              :disabled="isLoading"
            >
              Versturen
            </button>
            <button type="button" class="btn btn-secondary" @click="close">
              Annuleren
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NoteForm from "./NoteForm.vue";
export default {
  components: { NoteForm },
  name: "MailModal",
  props: {
    modelValue: {
      type: String,
    },
    booking: {
      type: Object,
    },
    mails: {
      type: String,
    },
  },
  data() {
    return {
      note: "",
      isLoading: false,
    };
  },
  methods: {
    close() {
      this.$emit("update:modelValue", null);
      this.isLoading = false;
    },
    async send() {
      this.isLoading = true;

      await axios.post(this.mailUrl);
      this.close();
    },
  },
  computed: {
    mailUrl() {
      let url = `/admin/bookings/mail?recipient=${this.modelValue}&booking=${this.booking.id}`;

      if (!!this.note) {
        url += `&note=${this.note}`;
      }

      return url;
    },
    isOpen() {
      return !!this.modelValue;
    },
  },
  watch: {
    isOpen(isOpen) {
      this.note = "";

      if (isOpen) {
        document.body.classList.add("modal-open");
      } else {
        document.body.classList.remove("modal-open");
      }
    },
  },
};
</script>